import styled from 'styled-components'
import { flexCenter, modifySize } from '../mixins'

export const Container = styled.div`
  ${({ theme }) => `
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 5;
    padding: @padding-small ${theme['padding-medium']};
    border-bottom: ${theme['header-border']};
    background-color: ${theme['header-theme']};
    color: ${theme['main-color']};
    background-image: ${theme['texture']};
    font-family: 'CustomBoldFont', sans-serif;
    font-size: ${theme['font-size']};
    & + div {
        margin-top:${modifySize(theme['margin-medium'], 5)};
    }
    @media ${theme['mobile']} {
        padding: ${theme['padding-small']};
        flex-direction: column;
    }
    `};
`

export const TitleContainer = styled.div`
  ${({ theme }) => `
  display: flex;
  width: 100%;
  align-items: center;
  @media ${theme['mobile']} {
    justify-content: space-evenly;
  }
    `};
`

export const Title = styled.div`
  ${({ theme }) => `
  h4 {
    display: inline;
    margin: ${theme['margin-zero']};
    padding: ${theme['padding-zero']} ${theme['padding-small']};
    color: inherit;
    transition: ${theme['transition-time']} color;
    text-transform: uppercase;
  }
  img {
    width: 30px;
    padding: ${theme['padding-small']} ${theme['padding-zero']} ${theme['padding-zero']} ${theme['padding-small']};
  }
  p {
    margin: ${theme['padding-zero']} ${theme['padding-zero']} ${theme['padding-zero']} ${theme['padding-small']};
    text-align: center;
  }
  &:hover {
    h4,
    p {
      color: ${theme['main-color']};
    }
  }
    `};
`

export const Description = styled.p`
  ${({ theme, hidden }) => `
  @media ${theme['tablet']}, ${theme['desktop']} {
    max-height: ${hidden ? 0 : 100}px;
    opacity: ${hidden ? 0 : 1};
    transition: ${theme['transition-time']} max-height ease, ${
    theme['transition-time']
  } opacity ease,
      ${theme['transition-time']} color ease;
  }
    `};
`

export const List = styled.div`
  ${({ theme, collapsedMenu }) => `
  ${flexCenter()}
  flex-wrap: nowrap;
  ul {
    list-style: none;
    ${flexCenter()}
    flex-wrap: nowrap;
    margin: ${theme['margin-zero']} ${theme['margin-medium']};
    padding: ${theme['padding-zero']};
    @media ${theme['mobile']} {
      margin-top: ${theme['margin-small']};
    }
    li {
      margin: ${theme['margin-zero']} ${theme['margin-small']};
      a {
        text-transform: uppercase;
        transition: ${theme['transition-time']} color;
        &:hover {
          cursor: pointer;
          color: ${theme['main-color']};
        }
      }
    }
  }
  @media ${theme['mobile']} {
    flex-direction: column;
    margin-top: ${theme['margin-small']};
  }
    `};
  ${({ theme, collapsedMenu }) =>
    collapsedMenu
      ? `
    @media ${theme['mobile']} {
        max-height: 0px;
        margin: 0px;
        opacity: 0;
        transition: ${theme['transition-time']}  max-height ease, ${theme['transition-time']}  margin ease,
        ${theme['transition-time']}  opacity ease;
      }
    `
      : `
    @media ${theme['mobile']} {
        max-height: 200px;
        opacity: 1;
        transition: ${theme['transition-time']}  max-height ease, ${theme['transition-time']}  opacity ease;
      }
    `}
`

export const MenuButton = styled.div`
  ${({ theme }) => `
  display: none;
  @media ${theme['mobile']} {
    display: block;
    margin-left: ${theme['margin-medium']};
  }
    `};
`
